<template>
  <div class="bg-white p-3">
    <div class="d-flex flex-column">
      <VInputWrapper
        class="m-2"
        :label="trans('core.starttime')"
        :errors="getErrors('starttime')"
        name="starttime"
      >
        <QueryDateTimePicker
          id="starttime"
          v-model="params.starttime"
          :disabled="isSaving"
        />
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('core.endtime')"
        :errors="getErrors('endtime')"
        name="endtime"
      >
        <QueryDateTimePicker
          id="endtime"
          v-model="params.endtime"
          :disabled="isSaving"
        />
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('core.location')"
        :errors="getErrors('location')"
        name="location"
      >
        <select
          v-model="params.location"
          class="form-control"
          :disabled="isSaving"
        >
          <option value="student_dashboard">
            {{ trans('admin.system_messages.locations.student_dashboard') }}
          </option>
          <option value="employee_dashboard">
            {{ trans('admin.system_messages.locations.employee_dashboard') }}
          </option>
          <option value="login">
            {{ trans('admin.system_messages.locations.login') }}
          </option>
        </select>
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('core.style')"
        :errors="getErrors('style')"
        name="style"
      >
        <select
          v-model="params.style"
          class="form-control"
          :disabled="isSaving"
        >
          <option value="info">
            {{ trans('admin.system_messages.styles.info') }}
          </option>
          <option value="success">
            {{ trans('admin.system_messages.styles.success') }}
          </option>
          <option value="warning">
            {{ trans('admin.system_messages.styles.warning') }}
          </option>
          <option value="danger">
            {{ trans('admin.system_messages.styles.danger') }}
          </option>
        </select>
      </VInputWrapper>

      <button
        type="button"
        class="btn btn-primary float-right m-2"
        @click="$emit('change-step', 1)"
      >
        {{ trans('core.next') }}
      </button>
    </div>
  </div>
</template>

<script>
import QueryDateTimePicker from '@/employees/components/QueryDateTimePicker.vue'

export default {
  name: 'SystemMessageDetailsEdit',
  components: { QueryDateTimePicker },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {},
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data () {
    return {
      params: {
        starttime: null,
        endtime: null,
        location: null,
        style: 'info',
      },
    }
  },

  watch: {
    params: {
      handler: function (value) {
        this.updateValue()
      },
      deep: true,
    },
  },

  mounted () {
    if (this.value?.starttime != null) {
      this.params.starttime = this.value.starttime
    }

    if (this.value?.endtime != null) {
      this.params.endtime = this.value.endtime
    }

    if (this.value?.location != null) {
      this.params.location = this.value.location
    }

    if (this.value?.style != null) {
      this.params.style = this.value.style
    }
  },

  methods: {
    updateValue () {
      this.$emit('input', this.params)
    },

    getErrors (field) {
      const errors = this.errors[field] ?? []

      return errors.map(message => {
        return { message }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-primary {
  background-color: #646B78 !important;
}
</style>
